import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { Form } from '@/common/components/Form.tsx'
import InformationPopover from '@/common/components/InformationPopover.tsx'
import { Input } from '@/common/components/Input.tsx'
import { InformationIcon } from '@/common/icons/general.tsx'
import { useTranslation } from 'react-i18next'

const StepId = 1 as const
export default function BasicInfo() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const validateForm = () => {
    setStepCompleted(StepId)
    goNext()
  }

  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>{translate('basic_information')}</WizardStepTitle>
        <WizardStepContent>
          <Form className="max-w-xl mx-auto">
            <div className="flex flex-col space-y-3">
              <div>
                <label
                  htmlFor="schoolname"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('school_name')}
                  <span className="text-danger ml-1">*</span>
                </label>
                <div className="mt-1">
                  <Input
                    id="schoolname"
                    name="schoolname"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="firstname"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('your_first_name')}
                  <span className="text-danger ml-1">*</span>
                  <InformationPopover message="This is the first name of the applicant">
                    <InformationIcon className="text-md ml-1" />
                  </InformationPopover>
                </label>
                <div className="mt-1">
                  <Input
                    id="firstname"
                    name="firstname"
                    type="text"
                    autoComplete="given-name"
                    required
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="lastname"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('your_last_name')}
                  <span className="text-danger ml-1">*</span>
                  <InformationPopover message="This is the last name of the applicant">
                    <InformationIcon className="text-md ml-1" />
                  </InformationPopover>
                </label>
                <div className="mt-1">
                  <Input
                    id="lastname"
                    name="lastname"
                    type="text"
                    autoComplete="family-name"
                    required
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  {translate('email')}
                  <span className="text-danger ml-1">*</span>
                  <InformationPopover message="This email will be used for your invitation and all communications. Once the application is complete, you cannot update it. It is best for you use a general business contact email.">
                    <InformationIcon className="text-md ml-1" />
                  </InformationPopover>
                </label>
                <div className="mt-1">
                  <Input
                    id="email"
                    name="email"
                    type="text"
                    autoComplete="email"
                    required
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="phone"
                  className="text-sm font-medium leading-6 text-gray-900 flex items-center"
                >
                  {translate('applicant_phone_number')}
                  <span className="text-danger ml-1">*</span>
                  <InformationPopover message="This number will be used to contact you in the event of any emergency">
                    <InformationIcon className="text-md ml-1" />
                  </InformationPopover>
                </label>
                <div className="mt-1 flex rounded-md shadow-sm">
                  <select
                    id="country-code"
                    name="country-code"
                    className="rounded-l-md border-0 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary text-sm"
                    defaultValue="1"
                  >
                    <option value="1">{translate('us')}</option>
                    <option value="2">{translate('ca')}</option>
                  </select>
                  <div className="flex-grow">
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      autoComplete="tel"
                      required
                      placeholder="(123) 456-7890"
                      className="rounded-none rounded-r-md"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter onNext={validateForm} />
    </>
  )
}
